export default __webpack_public_path__ + "static/media/manage-customers.352d5ed0.svg";